module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAAMCAYAAAC0qUeeAAAABHNCSVQICAgIfAhkiAAAAHxJREFUKFONkdERQEAMRN91SCd0QAdUgA6UQAdKoAMqYHYmZ4wh5O8mb3ObTQBmoAFqYMWpAOzWlygH+jf+CkdmMNF0Fz3BkWlNdFrzYIkEVkCpxxccf9E+6V94AZIveAMKs+La6IDsmv3T5NEgNzr50iT3KNpUmSoi99wH42IibehPXjUAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/images/ico-arrow.png
// module id = 478
// module chunks = 0